import axios from "axios";
import qs from "qs";
import * as actionType from "../../../constant/actionType";

export const GetWorkersForClientInductionReport = (apiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/admin/client/GetWorkersForClientInductionReport`,
      params: apiData,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
